import { render, staticRenderFns } from "./TvConfigAction.vue?vue&type=template&id=7dbf2c90&scoped=true"
import script from "./TvConfigAction.vue?vue&type=script&lang=js"
export * from "./TvConfigAction.vue?vue&type=script&lang=js"
import style0 from "./TvConfigAction.vue?vue&type=style&index=0&id=7dbf2c90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbf2c90",
  null
  
)

export default component.exports